import { createFileRoute } from "@tanstack/react-router"

import TabsLayout from "@/components/common/TabsLayout/TabsLayout"

const tabs = [
  {
    id: "accounts-chart",
    label: "Chart of Accounts",
    path: "/app/admin/accounting/accounts-chart",
  },
  {
    id: "payment-terms",
    label: "Payment Terms",
    path: "/app/admin/accounting/payment-terms",
  },
]

export const Route = createFileRoute("/app/admin/accounting/_layout")({
  component: AccountingLayout,
})

function AccountingLayout() {
  return <TabsLayout title='Accounting Admin' tabs={tabs} />
}
